import Section from "components/Section";
import Title from "components/Title";
import { motion } from "framer-motion";
import React, { useMemo } from "react";
import { framerMotionAnimation } from "utils/animation";
import urls from "utils/urls";
import styles from "./styles.module.scss";

const Projects: React.FC = () => {
  const images = useMemo(
    () => [
      urls.images("projects/project1.jpg"),
      urls.images("projects/project2.jpg"),
      urls.images("projects/project3.jpg"),
      urls.images("projects/project4.jpg"),
      urls.images("projects/project5.jpg"),
      urls.images("projects/project6.jpg"),
    ],
    []
  );

  return (
    <Section className={styles.container} id="projects" label="Projects">
      <Title title="<highlight>Recent Projects</highlight>" />

      <div className={styles.projects}>
        {images.map((image) => (
          <motion.div
            className={styles.item}
            key={image}
            {...framerMotionAnimation}
          >
            <div
              className={styles.image}
              style={{ backgroundImage: `url(${image})` }}
            />
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default Projects;
